import BaseCardBehavior from './BaseCardBehavior';
import CardStateHelper, { getCardsState } from '../CardStateHelper';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import { CardTask } from '../CardTasks';
import { SCORE_KEY_CARD, SCORE_LOCK_CARD } from '../../../Constants/Score';
import { IGameState } from '../../Game/IGameState';
import { CardState } from 'Prototype/Level/Card/CardState';
import CardStateModifierHelper from '../CardStateModifierHelper';

export default class KeyCardBehavior extends BaseCardBehavior {
    public play(state: IGameState): IGameState {
        const currentCardState = CardStateHelper.getCardState(state, this.cardID);

        const targets: string[] = [];

        if (currentCardState === CardState.IN_PLAY) {
            // Discard this card.
            state = CardStateHelper.setCardDiscarded(state, this.cardID);

            // Find all lock cards and discard them (even if they are obscured/facedown).
            CardStateHelper.getCardsInPlay(state.levelState.cardsState, {
                requireCardTypes: [CardType.lock],
            }).forEach((cardID: string) => {
                state = CardStateHelper.setCardDiscarded(state, cardID);
                targets.push(cardID);
            });
        }

        let cardsState = getCardsState(state);

        // Add score.
        const scores: number[] = [SCORE_KEY_CARD, ...Array(targets.length).fill(SCORE_LOCK_CARD)];
        cardsState = CardStateHelper.addTurnScore(cardsState, ...scores);

        // Trigger key unlock animation task.
        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.KEY,
            cards: [this.cardID, ...targets],
            cardsScore: [...scores],
        });

        // Clear undo history when a key card is played.
        cardsState = CardStateHelper.clearUndoHistory(cardsState);

        state = CardStateHelper.updateGameState(state, cardsState);
        state = CardStateHelper.updateCards(state);
        state = CardStateModifierHelper.onCardPlayed(state, this.cardID);

        return state;
    }
}
